import { useEffect } from "react";
import { signInUrl } from "../lib/api";
import { BrandGlyph } from "../components/BrandMark";

/** Signed out: off to Flashsuite to sign in, coming back to this page. */
export function SignInRedirect() {
  useEffect(() => {
    window.location.replace(signInUrl(window.location.pathname + window.location.search));
  }, []);
  return <AuthSplash />;
}

/** First-load splash while the session check (`GET /auth/me`) is in flight. */
export function AuthSplash() {
  return (
    <div className="authroot splash">
      <BrandGlyph size={44} className="splashmark" />
    </div>
  );
}
